'use client';

import { Chip, FormControl, InputLabel, MenuItem, Select, Stack } from '@mui/material';

import { findSelectedBuildings } from '../../../utils';

export const BuildingsMultiSelect = ({ formData, buildings, disabled, handleInputChangeLeasingRight }) => (
	<FormControl style={{ width: '100%' }}>
		<InputLabel id='select-buildings-label'>Buildings</InputLabel>
		<Select
			id='buildings-leasing-right'
			label='Buildings'
			name='buildings'
			value={findSelectedBuildings(buildings, formData.buildings)}
			labelId='select-buildings-label'
			onChange={(e) => {
				handleInputChangeLeasingRight(e);
			}}
			autoComplete='off'
			multiple
			disabled={disabled}
			data-cy='buildings-multiselect'
			renderValue={(selectedBuildings) => (
				<Stack gap={1} direction='row' flexWrap='wrap'>
					{selectedBuildings.map((building) => (
						<Chip
							size='small'
							key={`building-chip-${building.id}`}
							onMouseDown={(e) => {
								e.stopPropagation();
							}}
							onDelete={
								disabled
									? null
									: () => {
											// remove value
											handleInputChangeLeasingRight({
												target: {
													name: 'buildings',
													value: selectedBuildings.filter((b) => b.id !== building.id),
												},
											});
										}
							}
							label={building.name}
						/>
					))}
				</Stack>
			)}
		>
			{!buildings?.length ? (
				<MenuItem key='no-buildings'>No available buildings configured for this facility</MenuItem>
			) : (
				buildings.map((building) => (
					<MenuItem key={`building-${building.id}`} value={building}>
						{building.name}
					</MenuItem>
				))
			)}
		</Select>
	</FormControl>
);

export default BuildingsMultiSelect;
